var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass()},[_c('apexchart',{attrs:{"width":"100%","type":"line","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }